// Map id -> name lookups for FK columns.
import { useGetAcademicYearsQuery } from "@/redux/slices/academicYearApi";
import { useGetSubjectsQuery } from "@/redux/slices/subjectApi";
import { useGetChaptersQuery } from "@/redux/slices/chapterApi";

export function useLookups() {
  const years = useGetAcademicYearsQuery({ limit: 100 });
  const subjects = useGetSubjectsQuery({ limit: 500 });
  const chapters = useGetChaptersQuery({ limit: 1000 });

  const yearName = (id?: string) =>
    years.data?.data.find((y) => y.id === id)?.name ?? "—";
  const subjectName = (id?: string) =>
    subjects.data?.data.find((s) => s.id === id)?.name ?? "—";
  const chapterName = (id?: string) =>
    chapters.data?.data.find((c) => c.id === id)?.name ?? "—";

  return {
    years: years.data?.data ?? [],
    subjects: subjects.data?.data ?? [],
    chapters: chapters.data?.data ?? [],
    yearName,
    subjectName,
    chapterName,
  };
}
